//import { CapacityPerWeek } from 'types/store/weeklyTeamCapacity';
import { AxiosInstance, CancelToken } from 'axios';
import axios from 'axios';
import { get } from 'lodash';
import config from 'config/Config';
import { initAxios } from 'utils/axios';

export interface WeeklyTeamMemberProjectCapacityApiResponse {
  userId: string;
  projectId: string;
  weeklyCapacities: any;
  links: {
    next: string;
    prev: string;
  };
}

export interface FetchWeeklyTeamMemberProjectCapacityParams {
  teamId: string;
  memberId: string;
  projectId: string;
  startDate: string;
  endDate?: string;
  url?: string;
  cancelToken?: CancelToken;
}

class WeeklyTeamMemberProjectCapacityAPI {
  instance: AxiosInstance;

  constructor() {
    this.instance = initAxios(config.get('backendURL'), 'resourcing');
  }

  fetchWeeklyCapacityForTeamMemberProject = async ({
    teamId,
    memberId,
    projectId,
    startDate,
    endDate,
    url: providedUrl,
    cancelToken,
  }: FetchWeeklyTeamMemberProjectCapacityParams): Promise<WeeklyTeamMemberProjectCapacityApiResponse> => {
    const url =
      providedUrl ||
      `/v2/teams/${teamId}/members/${memberId}/projects/${projectId}/capacities/weekly`;

    const response =
      await this.instance.get<WeeklyTeamMemberProjectCapacityApiResponse>(
        url,
        providedUrl
          ? { cancelToken }
          : {
              params: {
                startDate,
                endDate,
              },
              cancelToken,
            }
      );
    if (axios.isAxiosError(response)) {
      const errorMessage = get(response, 'response.data.message', '');
      throw errorMessage;
    }
    return response.data;
  };
}

const weeklyTeamMemberProjectCapacityAPI =
  new WeeklyTeamMemberProjectCapacityAPI();

export default weeklyTeamMemberProjectCapacityAPI;

export { WeeklyTeamMemberProjectCapacityAPI };

export const fetchWeeklyCapacityForTeamMemberProject = async (
  params: FetchWeeklyTeamMemberProjectCapacityParams
): Promise<WeeklyTeamMemberProjectCapacityApiResponse> => {
  return weeklyTeamMemberProjectCapacityAPI.fetchWeeklyCapacityForTeamMemberProject(
    params
  );
};
